export const uuidV5Namespace = "817793b3-3c57-4b57-86fc-42d700a89b0e";
